import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12818269"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper p-1 p-md-3" }
const _hoisted_2 = { class: "font-weight-bold mb-4 d-flex flex-row justify-content-between align-items-center p-3 p-lg-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-cog" })
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Schaltzeiten konfigurieren ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header bg-white" }
const _hoisted_9 = { class: "font-weight-bold" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }
const _hoisted_13 = { class: "btn bg-transparent border-blue text-blue rounded-round border-2 btn-icon mr-3" }
const _hoisted_14 = { class: "flex-fill d-flex flex-column" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = {
  key: 0,
  class: "float-right"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_21 = {
  key: 1,
  class: "row mb-3"
}
const _hoisted_22 = { class: "pt-2 col-12 col-xl-8" }
const _hoisted_23 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_24 = { class: "pt-3 col-12 col-xl-4" }
const _hoisted_25 = {
  key: 0,
  class: "card"
}
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Schaltzeiten ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["id"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3 border-blue text-blue" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fad fa-repeat text-blue" })
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-blue" }, "Intervall")
], -1))
const _hoisted_34 = { class: "media-body align-self-center" }
const _hoisted_35 = { class: "font-weight-bold" }
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = { class: "badge bg-slate" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3 border-success text-success" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-switch" })
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-success" }, "Unscharf")
], -1))
const _hoisted_39 = { class: "media-body align-self-center" }
const _hoisted_40 = { class: "font-weight-bold" }
const _hoisted_41 = { class: "badge bg-slate" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3 border-danger text-danger" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-switch" })
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "Scharf")
], -1))
const _hoisted_43 = { class: "media-body align-self-center" }
const _hoisted_44 = { class: "font-weight-bold" }
const _hoisted_45 = { class: "badge bg-slate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircuitDiagram = _resolveComponent("CircuitDiagram")!
  const _component_Timetable = _resolveComponent("Timetable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.headline) + " ", 1),
      (_ctx.userRights.arming?.write)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-accent btn-labeled btn-labeled-left btn-sm",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.configSwitchingTimes && _ctx.configSwitchingTimes(...args)))
          }, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, pIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: pIndex,
          class: "col-12"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h5", _hoisted_9, [
                _createTextVNode(_toDisplayString(project.p_firma) + " | ", 1),
                _createElementVNode("small", null, "#" + _toDisplayString(project.pid), 1)
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(project.p_strasse) + " " + _toDisplayString(project.p_hnr) + ", " + _toDisplayString(project.p_plz) + " " + _toDisplayString(project.p_ort), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.systems, (system, sIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: sIndex }, [
                  _createElementVNode("legend", _hoisted_12, [
                    _createElementVNode("a", _hoisted_13, [
                      _createElementVNode("i", {
                        class: _normalizeClass(system.icon),
                        "aria-hidden": "true"
                      }, null, 2)
                    ]),
                    _createElementVNode("span", _hoisted_14, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(system.anlage_bemerkung) + " | ", 1),
                        _createElementVNode("small", null, "#" + _toDisplayString(system.anlage_nummer), 1)
                      ]),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.stringToDate(system.anlage_einbau, 'de')), 1)
                    ]),
                    (_ctx.userRights.arming?.write)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: ($event: any) => (_ctx.goToSystemSwitchingTimes(project.pid, system.anlage_id))
                          }, _hoisted_19, 8, _hoisted_17)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!system.intervalAvailable && !system.onAvailable && !system.offAvailable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Für diesen Anlagentyp können keine Schaltzeiten konfiguriert werden "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          (system.armingSchedule)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (system.intervalAvailable)
                                  ? (_openBlock(), _createBlock(_component_CircuitDiagram, {
                                      key: 0,
                                      times: system,
                                      editable: false
                                    }, null, 8, ["times"]))
                                  : (_openBlock(), _createBlock(_component_Timetable, {
                                      key: 1,
                                      times: system,
                                      editable: false
                                    }, null, 8, ["times"]))
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, "Die Funktion steht für diese Anlage nicht zur Verfügung, wenden Sie sich bitte an Ihren Errichter"))
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          (system.armingSchedule)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("h6", _hoisted_27, [
                                    _createElementVNode("a", {
                                      class: "text-body collapsed d-flex flex-row align-items-center justify-content-between",
                                      href: '#collapse-icon'+system.anlage_id,
                                      "data-toggle": "collapse"
                                    }, [
                                      _hoisted_29,
                                      _createElementVNode("a", {
                                        href: "",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                                        class: "text-body",
                                        "data-toggle": "collapse",
                                        "aria-expanded": "false"
                                      }, _hoisted_31)
                                    ], 8, _hoisted_28)
                                  ])
                                ]),
                                _createElementVNode("ul", {
                                  class: "media-list media-list-linked media-list-bordered collapse",
                                  id: 'collapse-icon'+system.anlage_id
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.interval, (interval, iIndex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: iIndex,
                                      class: "media bg-white"
                                    }, [
                                      _hoisted_33,
                                      _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                          _createTextVNode(_toDisplayString(interval.validateTime.start.hours) + ":" + _toDisplayString(interval.validateTime.start.minutes) + " - " + _toDisplayString(interval.validateTime.end.hours) + ":" + _toDisplayString(interval.validateTime.end.minutes) + " ", 1),
                                          _createElementVNode("span", _hoisted_36, " ( " + _toDisplayString(interval.validateTime.duration.hours) + ":" + _toDisplayString(interval.validateTime.duration.minutes) + " Stunden ) ", 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_37, _toDisplayString(interval.validateTime.weekday), 1)
                                      ])
                                    ]))
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.on, (on, onIndex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: onIndex,
                                      class: "media"
                                    }, [
                                      _hoisted_38,
                                      _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, _toDisplayString(on.validateTime.start.hours) + ":" + _toDisplayString(on.validateTime.start.minutes), 1),
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(on.validateTime.weekday), 1)
                                      ])
                                    ]))
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.off, (off, offIndex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: offIndex,
                                      class: "media"
                                    }, [
                                      _hoisted_42,
                                      _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, _toDisplayString(off.validateTime.start.hours) + ":" + _toDisplayString(off.validateTime.start.minutes), 1),
                                        _createElementVNode("span", _hoisted_45, _toDisplayString(off.validateTime.weekday), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ], 8, _hoisted_32)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                ], 64))
              }), 128))
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}